import { Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { useTranslation } from "react-i18next";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import { PieChartEmpty } from "../ChartsLayout/EmptyCharts.jsx";
import { labelMappings } from "./chartUtilies.js";
export default function DistributionPieChartComponent({
  data,
  title,
  tKeyPrefix,
  mappings = labelMappings,
}) {
  const isEmpty = !data || Object.keys(data).length === 0;
  // if (tKeyPrefix === "education") {
  //   console.log("Data in pie chart of education distribution ", data);
  // }

  const { t } = useTranslation("homepage");
  const chartData = isEmpty
    ? []
    : Object.entries(data).map(([rawLabel, value], index) => {
        const normalized = String(rawLabel).toLowerCase().trim();
        // console.log("Normalized", normalized);
        const mapped = (
          mappings[rawLabel] ??
          mappings[normalized] ??
          normalized
        ).toLowerCase();
        // console.log("Mapped", mapped);

        const key = tKeyPrefix ? `${tKeyPrefix}.${rawLabel}` : rawLabel;
        // console.log("key", key);

        const translated = t(key, { defaultValue: "" });
        // console.log("translated", translated);

        const label = translated || mapped || rawLabel;
        // console.log("label", label);

        return { id: index, value, label };
      });

  return (
    <ResponsiveCharts>
      {({
        isVerySmall,
        chartWidth,
        chartWidthPie,
        pieProps,
        pieChartPaddingLabel,
        pieChartLabelDirection,
        pieChartLabelPosition,
        pieChartMargin,
      }) =>
        isEmpty ? (
          <>
            {title && (
              <Typography
                variant="h6"
                sx={{ textAlign: "center", marginBottom: "27px" }}
              >
                {title}
              </Typography>
            )}
            <PieChartEmpty
              title={title}
              chartWidth={isVerySmall ? chartWidthPie : chartWidth}
              height={280}
              pieProps={pieProps}
              pieChartLabelDirection={pieChartLabelDirection}
              pieChartLabelPosition={pieChartLabelPosition}
              pieChartPaddingLabel={pieChartPaddingLabel}
            />
          </>
        ) : (
          <>
            {title && (
              <Typography
                variant="h6"
                sx={{ textAlign: "center", marginBottom: "27px" }}
              >
                {title}
              </Typography>
            )}
            <PieChart
              margin={pieChartMargin}
              series={[
                {
                  data: chartData,
                  arcLabel: (item) => {
                    return item.value < 5 ? "" : `${item.value.toFixed(1)}%`;
                  },
                  ...pieProps,
                },
              ]}
              width={isVerySmall ? chartWidthPie : chartWidth}
              height={280}
              slotProps={{
                legend: {
                  direction: pieChartLabelDirection,
                  position: pieChartLabelPosition,
                  padding: pieChartPaddingLabel,
                  itemMarkWidth: 20,
                  itemMarkHeight: 3,
                  markGap: 5,
                  itemGap: 5,
                },
              }}
            />
          </>
        )
      }
    </ResponsiveCharts>
  );
}
